import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import "./AccountSidebar.css";
import CoveragePeriod from "./CoveragePeriod/CoveragePeriod";
import TauriImage from "../../TauriImage/TauriImage";
import { getAll, getRecordById } from "../../../localDB";
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import AccountDetailsModal from "../AccountDetailsModal/AccountDetailsModal";
import appUrl from '../../../appURL.json';
import AccountInfoSection from './AccountInfoSection/AccountInfoSection';
import OpalAccountBasicInfo from "../../OpalAccountInfoDetails/OpalAccountBasicInfo/OpalAccountBasicInfo";
import OpalAccountAddressDetails from "../../OpalAccountInfoDetails/OpalAccountAddressDetails/OpalAccountAddressDetails";
import OpalAccountTerritorialConfiguration from "../../OpalAccountInfoDetails/OpalAccountTerritorialConfiguration/OpalAccountTerritorialConfiguration";
import OpalAccountCoverage from "../../OpalAccountInfoDetails/OpalAccountCoverage/OpalAccountCoverage";
import OpalAccountCategorization from "../../OpalAccountInfoDetails/OpalAccountCategorization/OpalAccountCategorization";

const AccountSidebar = ({ open, onClose, accID }) => {
    const [activeTab, setActiveTab] = useState("account");
    const [coverageHistory, setCoverageHistory] = useState([]);
    const [loadingCoverageHistory, setLoadingCoverageHistory] = useState(true);
    const [accountInfo, setAccountInfo] = useState(null);
    const [loadingAccountInfo, setLoadingAccountInfo] = useState(false);

    const handleEdit = (title, section) => {

    }

    const fetchCoverageHistory = async (accID) => {
        setLoadingCoverageHistory(true);
        try {
            const sessions = await getAll("session");
            const account = await getRecordById("customer", accID);
            const sessionsFiltered = sessions.filter((a) => a.AccountID === accID);



            const groupedByCycle = sessionsFiltered.reduce((acc, session) => {
                if (!acc[session.CyclePeriodID]) {
                    acc[session.CyclePeriodID] = []
                }

                acc[session.CyclePeriodID].push({
                    ID: session.ID,
                    Date: session.SessionDate,
                    Status: session.Status,
                    Joint: session.Joint,
                    Account: account.Name
                });
                return acc;
            }, {});

            const result = await Promise.all(
                Object.entries(groupedByCycle).map(async ([cycleId, sessionList]) => {
                    const cycle = await getRecordById("Cycle", Number(cycleId));
                    return {
                        Cycle: {
                            Code: cycle.Code,
                            Description: cycle.Description
                        },
                        Session: sessionList
                    };
                })
            );

            setCoverageHistory(result);

        } catch (err) {
            console.log(err)
        } finally {
            setLoadingCoverageHistory(false);
        }
    }

    const fetchAccountInfo = async (accID) => {
        setLoadingAccountInfo(true);
        try {
            const token = localStorage.getItem('token');
            const devId = localStorage.getItem('devId');
            const response = await fetch(`${appUrl.API_GetAccountDetails}/${accID}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                }
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();
            setAccountInfo(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingAccountInfo(false);
        }
    };

    const handleUpdateBasicInfo = (data) => {

    }

    useEffect(() => {
        if (accID) {
            fetchAccountInfo(accID);
            fetchCoverageHistory(accID);
        }
    }, [accID])

    return (
        <>
            {/* Overlay */}
            {open && <div className="overlay-account" onClick={onClose}></div>}

            <div className={`opal-account-sidebar ${open ? "open" : ""}`}>
                {/* Header */}
                <div className="opal-account-sidebar-header">
                    <div>ACCOUNT DETAILS</div>
                    <TauriImage localImage={"/Images/basil--cross-outline.svg"} alt="icon" onClick={onClose} />
                </div>

                <div className="opal-account-sidebar-separator" />

                {/* Tabs with Content */}
                <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                    <Nav variant="tabs" className="opal-account-main-tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="account">ACCOUNT INFO</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="coverage">COVERAGE</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="quickviews">QUICK VIEWS</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <div className="opal-account-sidebar-content">
                        <Tab.Content>
                            {/* Account Info */}
                            <Tab.Pane eventKey="account">
                                {loadingAccountInfo ? (
                                    <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                                ) : (
                                    <>
                                        <AccountInfoSection
                                            title="Basic Information"
                                            data={accountInfo?.basicInfo}
                                            Component={OpalAccountBasicInfo}
                                            onEdit={handleUpdateBasicInfo} />
                                        <AccountInfoSection
                                            title="Address Details"
                                            data={accountInfo?.addressDetails}
                                            Component={OpalAccountAddressDetails}
                                            onEdit={handleUpdateBasicInfo} />
                                        <AccountInfoSection
                                            title="Territorial Configuration"
                                            data={accountInfo?.territorialConfig}
                                            Component={OpalAccountTerritorialConfiguration} />
                                        <AccountInfoSection
                                            title="Coverage"
                                            data={accountInfo?.coverage}
                                            Component={OpalAccountCoverage}
                                            onEdit={handleUpdateBasicInfo} />
                                        <AccountInfoSection
                                            title="Categorization"
                                            data={accountInfo?.categorization}
                                            Component={OpalAccountCategorization}
                                            onEdit={handleUpdateBasicInfo} />
                                    </>
                                )}
                            </Tab.Pane>

                            {/* Coverage */}
                            <Tab.Pane eventKey="coverage">
                                {loadingCoverageHistory ?
                                    <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" /> :
                                    <CoveragePeriod data={coverageHistory} />
                                }
                            </Tab.Pane>

                        </Tab.Content>
                    </div>
                </Tab.Container>
            </div>
        </>
    );
};

export default AccountSidebar;
